import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_FILE_API

// --------------------- 在线签章 开通与购买 ----------------------
// 判断是否开通在线签章
export function getSignatureOpenStatusApi() {
  return request({
    url: `${baseUrl}/esign/companies/exist`,
    method: 'get'
  })
}

// 开通在线签章申请
export function openSignatureApi(data) {
  return request({
    url: `${baseUrl}/esign/companies/open`,
    method: 'post',
    data
  })
}

// 查询在线签章套餐列表
export function getSignaturePackageListApi() {
  return request({
    url: `${baseUrl}/esign/skus`,
    method: 'get'
  })
}

// 套餐购买
export function buySignaturePackageApi(data) {
  return request({
    url: `${baseUrl}/esign/orders/pay`,
    method: 'post',
    data
  })
}

// 签章次数兑换
export function exchangeSignatureByVoucherApi(data) {
  return request({
    url: baseUrl + '/esign/accounts/redeem',
    method: 'post',
    data
  })
}

// 查询订单支付状态
export function getSignaturePurchaseStatusApi({ payNo }) {
  return request({
    url: `${baseUrl}/esign/orders/${payNo}/pay/status`,
    method: 'get'
  })
}

// 分页查询订单记录
export function getSignaturePurchaseRecordListApi(params) {
  return request({
    url: `${baseUrl}/esign/orders/buy/record/page`,
    method: 'get',
    params
  })
}

// 查询剩余签章次数
export function getSignatureRemainingCountApi() {
  return request({
    url: `${baseUrl}/esign/accounts/remain`,
    method: 'get'
  })
}

// 根据身份证查询在线签章经办人信息
export function getSignatureManagerInfoApi(idCard) {
  return request({
    url: `${baseUrl}/esign/commons/id-card/${idCard}/agent-info`,
    method: 'get'
  })
}

// ------------------------------  在线签章 员工 -----------------------------
// 分页查询员工信息列表 (仅管理员权限查看）
export function getESignEmployeeListApi(params) {
  return request({
    url: `${baseUrl}/esign/employees/page`,
    method: 'get',
    params
  })
}

// 获取员工基本信息 (目前没有使用)
export function getESignEmployeeDetailApi(employeeId) {
  return request({
    url: `${baseUrl}/esign/employees/${employeeId}/agent-info`,
    method: 'get'
  })
}

// 开通在线签章经办身份
export function addESignEmployeeInfoApi(employeeId, data) {
  return request({
    url: `${baseUrl}/esign/employees/${employeeId}/open`,
    method: 'post',
    data
  })
}

// 编辑在线签章的经办员工信息
export function editESignEmployeeInfoApi(employeeId, data) {
  return request({
    url: `${baseUrl}/esign/employees/${employeeId}/agent-info`,
    method: 'put',
    data
  })
}

// 删除在线签章权限
export function deleteESignEmployeeRightApi(employeeId) {
  return request({
    url: `${baseUrl}/esign/employees/${employeeId}`,
    method: 'delete'
  })
}

// 员工是否开通在线签章身份
export function isEmployeeHasESignRightApi() {
  return request({
    url: `${baseUrl}/esign/employees/exist`,
    method: 'get'
  })
}

// 获取签章文件所有人员信息 （业务端使用）
export function getAllSignerInfoApi() {
  return request({
    url: `${baseUrl}/esign/employees`,
    method: 'get'
  })
}

// ------------------------------ 签章任务 ------------------------------
// 新增任务 （业务端使用）
export function addESignTaskApi(data) {
  return request({
    url: `${baseUrl}/esign/tasks`,
    method: 'post',
    data
  })
}

// 分页查询任务列表
export function getESignTaskListApi(params) {
  return request({
    url: `${baseUrl}/esign/tasks/page`,
    method: 'get',
    params
  })
}

// 获取签章文件地址 (签章中状态获取签章文件地址使用）
export function getESignFileUrlApi(taskId) {
  return request({
    url: `${baseUrl}/esign/tasks/${taskId}/sign/url`,
    method: 'get'
  })
}

// 签署 （待签章状态获取签章文件地址使用）
export function signESignTaskApi(taskId) {
  return request({
    url: `${baseUrl}/esign/tasks/${taskId}/sign`,
    method: 'post'
  })
}

// 解除签章任务的锁定状态
export function unlockESignTaskApi(taskId) {
  return request({
    url: `${baseUrl}/esign/tasks/${taskId}/unlock`,
    method: 'post'
  })
}

// 撤回签章任务 （业务端使用）
export function backESignTaskApi(taskId) {
  return request({
    url: `${baseUrl}/esign/tasks/${taskId}/back`,
    method: 'post'
  })
}

// 拒绝签章任务
export function refuseESignTaskApi(taskId, data) {
  return request({
    url: `${baseUrl}/esign/tasks/${taskId}/refuse`,
    method: 'post',
    data
  })
}

// 签章人员通过权限获取文件预览地址
export function getESignFileUrlByRightApi({ taskId }) {
  return request({
    url: `${baseUrl}/esign/tasks/${taskId}/preview`,
    method: 'get'
  })
}

// 查询最新在线签章审核单
export function getESignAuditsLatestApi(needLoading) {
  return request(
    {
      url: `${baseUrl}/esign/audits/latest`,
      method: 'get'
    },
    needLoading
  )
}

// 新增在线签章审核单
export function getESignAuditsApi(data) {
  return request({
    url: `${baseUrl}/esign/audits`,
    method: 'POST',
    data
  })
}
